import { Contract } from 'ethers';
import getAddress from './getRnctAddress';
import abi from '../abis/RnctAbi.json';



export default function getRnctContract(chainNumber, library, withSigner) {
  const address = getAddress(chainNumber);
  if (!address) return null;
  if (withSigner)
    return new Contract(address, abi, library.getSigner());
  return new Contract(address, abi, library);
}
